export const SETTINGSCONFIG = {
  getExtrasOptions: 'vehicle/list-extras',
  updateExtrasOptions: 'booking/update-extras-price',
  addExtrasOption: 'booking/create-extra',
  deleteExtrasOption: 'booking/delete-extra',
  tableTabsDetail: [{ name: 'Pricing Info', key: 'pricingInfo', value: '', selected: true }],
};
